<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useModalsStore } from '@/stores/modals';
import { useUserStore } from '@/stores/user';
import { useSidebarStore } from '@/stores/sidebar';
import { useCamStore } from '@/stores/cam';
import { storeToRefs } from 'pinia';
import config from '@/config';

import modalLogin from './modal-login/modal-login.vue';
import modalRegister from './modal-register/modal-register.vue';
import modalLostPassword from './modal-lostpassword/modal-lostpassword.vue';
import modalResetPassword from './modal-resetpassword/modal-resetpassword.vue';
import modalCookie from './modal-cookie/modal-cookie.vue';
import modalLoader from './modal-loader/modal-loader.vue';
import modalClose from './modal-close/modal-close.vue';
import modalNew from './modal-new/modal-new.vue';
import modalUnlock from './modal-unlock/modal-unlock.vue';
import modalPayment from './modal-payment/modal-payment.vue';
import modalPaysafe from './modal-paysafe/modal-paysafe.vue';

import { getStaticImages } from '@/utils';

const { modals, hasActiveModals, getActiveModal } = storeToRefs(useModalsStore());
const { getModal, closeModal } = useModalsStore();
const userStore = useUserStore();
const camStore = useCamStore();
const sidebar = useSidebarStore();
const route = useRoute();

const isSubmitting = ref(false);

function loadLoader(status: boolean){
    isSubmitting.value = status;
}

const currentModal = computed(() => {
    return config.Themename && config.Themename !== 'thuis' && getActiveModal.value === 'cookiee' ? 'cookiee-dark' : getActiveModal.value;
});

const sidebarAdjustment = computed(() => {
    return route.name === 'videochat' && sidebar.bodyWidth as any > 992 ? true : false;
});

</script>

<template src="./modal.html"></template>

<style lang="scss">
@import './modal.scss';
</style>
